module.exports = __webpack_public_path__ + "static/011-2afa02aa8e5a7f145c56ba22bdd588cd.jpg";